module.exports = __webpack_public_path__ + "files/495fd2130c3ff9c862d838e0bf908dde.svg";